import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: [
    "Facebook Ads",
    "Facebook Organic",
    "facebook",
    "Facebook Ads - CA",
    "Facebook Ads - Organic",
    "Facebook Ads - Stores",
    "Facebook Ads - US",
    "Facebook Ads (Meta)",
    "Facebook Canada",
    "Facebook ESPANA",
    "Facebook Italia",
    "Facebook Organic (Meta)",
    "Facebook Organic",
    "Facebook Shop Orders",
    "Facebook Shop",
    "FB Email Sign Up",
    "FB Traffic Campaigns (remove me)",
    "Meta Shops",
    "fb",
  ],
  iconColor: "#7081FF", // cosmic
  getIcon(options) {
    return createIcon(
      `
      <path
        d="M10.6705 12.6446C10.6288 12.6446 9.70998 12.6446 9.29234 12.6446C9.06961 12.6446 9 12.5695 9 12.3817C9 11.8811 9 11.368 9 10.8673C9 10.6671 9.08353 10.6045 9.29234 10.6045H10.6705C10.6705 10.567 10.6705 9.84105 10.6705 9.50313C10.6705 9.0025 10.768 8.52691 11.0464 8.08886C11.3387 7.6383 11.7564 7.33792 12.2854 7.1627C12.6334 7.05006 12.9814 7 13.3573 7H14.7216C14.9165 7 15 7.07509 15 7.25031V8.6771C15 8.85232 14.9165 8.92741 14.7216 8.92741C14.3457 8.92741 13.9698 8.92741 13.594 8.93992C13.2181 8.93992 13.0232 9.10263 13.0232 9.45307C13.0093 9.82854 13.0232 10.1915 13.0232 10.5795H14.6381C14.8608 10.5795 14.9443 10.6546 14.9443 10.8548V12.3692C14.9443 12.5695 14.8747 12.632 14.6381 12.632C14.1369 12.632 13.065 12.632 13.0232 12.632V16.7121C13.0232 16.9249 12.9536 17 12.703 17C12.1183 17 11.5476 17 10.9629 17C10.7541 17 10.6705 16.9249 10.6705 16.7372C10.6705 15.423 10.6705 12.6821 10.6705 12.6446Z"
        fill="#3B5998"
      />
      `,
      "#F3F4FF", // cosmic-4
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
